/*
 * @Description:
 * @Author: Rfan
 * @Date: 2021-08-13 09:25:46
 * @LastEditTime: 2025-04-21 15:37:36
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import Service from '../views/Service.vue';
import Layout from '@/components/Layout.vue';
import { testApp } from '@/utils';

Vue.use(VueRouter)

const isHsjPro = testApp('hsjpro');

const routes = [
  {
    path: '/',
    redirect: '/service'
  },
  {
    path: '/service',
    name: 'service',
    component: Service,
    meta: {
      title: '画世界用户协议'
    },
  },
  {
    path: '/service/hsjpro',
    name: 'HsjProService',
    component: () => import(/* webpackChunkName: "HsjProService" */ '../views/hsjpro/Service.vue'),
    meta: {
      title: '画世界Pro用户协议'
    },
  },
  {
    path: '/privacy/:app?/:languages?',
    name: 'privacy',
    component: () =>
      import(/* webpackChunkName: "privacy" */ '../views/Privacy.vue'),
    meta: {
      title: '隐私政策'
    }
  },
  {
    // 画世界 未成年人隐私保护
    path: '/privacyprotectionforminors',
    name: 'PrivacyProtectionForMinors',
    component: () =>
      import(/* webpackChunkName: "HsjPriacyProtectionForMinors" */ '../views/hsj/PrivacyProtectionForMinors.vue'),
    meta: {
      title: '未成年人隐私保护'
    }
  },
  {
    path: '/permissions',
    name: 'Permissions',
    component: () =>
      import(/* webpackChunkName: "Permissions" */ '../views/Permissions.vue'),
    meta: {
      title: '设备权限清单'
    }
  },
  {
    path: '/member/:app?',
    name: 'member',
    component: () =>
      import(/* webpackChunkName: "member" */ '../views/Member.vue'),
    meta: {
      title: isHsjPro ? '画世界Pro会员协议' : '画世界会员协议'
    }
  },
  {
    path: '/term/:app?',
    name: 'term',
    component: () => import(/* webpackChunkName: "term" */ '../views/Term.vue'),
    meta: {
      title: '自动续费规则'
    }
  },
  {
    path: '/face',
    name: 'face',
    component: () => import(/* webpackChunkName: "face" */ '../views/Face.vue'),
    meta: {
      title: isHsjPro ? '画世界Pro人脸验证服务协议' : '画世界人脸验证服务协议'
    }
  },
  {
    path: '/rightsandobligations/transfer/hsjpro',
    name: 'TransferOfRightsAndObligations',
    component: () => import(/* webpackChunkName: "TransferOfRightsAndObligations" */ '../views/hsjpro/TransferOfRightsAndObligations.vue'),
    meta: {
      title: "画世界Pro权利义务转让协议"
    }
  },
  {
    path: '/mojing/hsjpro/service',
    name: 'MojingHsjProService',
    component: () => import(/* webpackChunkName: "MojingHsjProService" */ '../views/mojinghsjpro/Service.vue'),
    meta: {
      title: '画世界Pro用户协议'
    },
  },
  {
    path: '/mojing/hsjpro/privacy',
    name: 'MojingHsjProPrivacy',
    component: () =>
      import(/* webpackChunkName: "MojingHsjProPrivacy" */ '../views/mojinghsjpro/Privacy.vue'),
    meta: {
      title: '画世界Pro隐私政策'
    }
  },
  {
    path: '/mojing/hsjpro/privacy_debug',
    name: 'MojingHsjProPrivacyDebug',
    component: () =>
      import(/* webpackChunkName: "MojingHsjProPrivacyDebug" */ '../views/mojinghsjpro/PrivacyDebug.vue'),
    meta: {
      title: '画世界Pro隐私政策'
    }
  },
  {
    path: '/informationsharinglist',
    name: 'HsjInformationSharingList',
    component: () =>
      import(/* webpackChunkName: "HsjInformationSharingList" */ '../views/hsj/InformationSharingList.vue'),
    meta: {
      title: '第三方信息共享清单'
    }
  },
  {
    path: '/userinformationlist',
    name: 'HsjUserInformationList',
    component: () =>
      import(/* webpackChunkName: "HsjUserInformationList" */ '../views/hsj/UserInformationList.vue'),
    meta: {
      title: '个人信息收集清单'
    }
  },
  {
    path: '/mojing/hsjpro/privacy/children',
    name: 'MojingHsjProPrivacyForChildren',
    component: () =>
      import(/* webpackChunkName: "MojingHsjProPrivacyForChildren" */ '../views/mojinghsjpro/PrivacyForChildren.vue'),
    meta: {
      title: '画世界Pro儿童青少年隐私保护'
    }
  },
  {
    path: '/mojing/hsjpro/member',
    name: 'MojingHsjProMember',
    component: () =>
      import(/* webpackChunkName: "MojingHsjProMember" */ '../views/mojinghsjpro/Member.vue'),
    meta: {
      title: '画世界Pro会员协议'
    }
  },
  {
    path: '/mojing/hsjpro/informationsharinglist',
    name: 'MojingHsjProInformationSharingList',
    component: () =>
      import(/* webpackChunkName: "MojingHsjProInformationSharingList" */ '../views/mojinghsjpro/InformationSharingList.vue'),
    meta: {
      title: '画世界Pro第三方信息共享清单'
    }
  },
  {
    path: '/mojing/hsjpro/userinformationlist',
    name: 'MojingHsjProUserInformationList',
    component: () =>
      import(/* webpackChunkName: "MojingHsjProUserInformationList" */ '../views/mojinghsjpro/UserInformationList.vue'),
    meta: {
      title: '个人信息收集清单'
    }
  },
  // 画世界Pro 自动续费规则
  {
    path: '/mojing/hsjpro/term',
    name: 'MojingHsjProTerm',
    component: () =>
      import(/* webpackChunkName: "MojingHsjProTerm" */ '../views/mojinghsjpro/Term.vue'),
    meta: {
      title: '自动续费规则'
    }
  },
  // 画世界Pro 人脸协议
  {
    path: '/mojing/hsjpro/face',
    name: 'MojingHsjProFace',
    component: () =>
      import(/* webpackChunkName: "MojingHsjProFace" */ '../views/mojinghsjpro/Face.vue'),
    meta: {
      title: '画世界Pro人脸验证服务协议'
    }
  },
  {
    path: '/opensource/:app?/:platform?',
    name: 'OpenSource',
    component: () =>
      import(/* webpackChunkName: "OpenSource" */ '../views/OpenSource.vue'),
    meta: {
      title: '开源软件声明'
    }
  },
  {
    path: '/informationcollection',
    name: 'InformationCollection',
    component: Layout,
    redirect: '/informationcollection/index',
    children: [
      {
        path: 'index',
        name: 'InformationCollectionIndex',
        meta: { title: '个人信息收集清单' },
        component: () => import( /* webpackChunkName: "InformationCollectionIndex" */
          '../views/informationcollection/index.vue'),
      },
      {
        path: 'detail/:id',
        name: 'InformationCollectionDetail',
        meta: { title: '个人信息收集清单详情' },
        component: () => import( /* webpackChunkName: "InformationCollectionDetail" */
          '../views/informationcollection/detail.vue'),
      },
      {
        path: 'download/success',
        name: 'InformationCollectionDownloadSuccess',
        meta: { title: '个人信息下载' },
        component: () => import( /* webpackChunkName: "InformationCollectionDownloadSuccess" */
          '../views/informationcollection/downloadSubmitSuccess.vue'),
      },
      {
        path: 'download/sms',
        name: 'InformationCollectionSmsVerify',
        meta: { title: '安全验证' },
        component: () => import( /* webpackChunkName: "InformationCollectionSmsVerify" */
          '../views/informationcollection/smsVerify.vue'),
      },
    ]
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
    let link = document.querySelector("[rel='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    if (to.meta.icon) {
      link.setAttribute('href', `${to.meta.icon}`);
    } else if (to.path?.indexOf('hsjpro') >= 0) {
      link.setAttribute('href', `${process.env.VUE_APP_CDN_PATH}favicon_pro.ico`);
    } else {
      link.setAttribute('href', `${process.env.VUE_APP_CDN_PATH}favicon.ico`);
    }
  }

  next()
});

export default router
